import { Root } from "mdast";
import { Plugin } from "unified";
import { visit } from "unist-util-visit";

const remarkGridPlugin: Plugin<[], Root> = () => {
  let inGrid = false;

  return (tree) => {
    visit(tree, "text", (node: any) => {
      if (node.value.includes("@@@")) {
        if (node.value.trim().startsWith("@@@") && !inGrid) {
          inGrid = true;
          const startTag = node.value.trim();
          const columnSettings = startTag.slice(3).split(";");
          const numColumns = parseInt(
            columnSettings.length > 0 ? columnSettings[0] : "1"
          );
          const colGap = parseInt(
            columnSettings.length > 1 ? columnSettings[1] : "4"
          );
          node.type = "html";
          node.value = `<div class="grid grid-cols-1 md:grid-cols-${Math.min(
            numColumns,
            2
          )} lg:grid-cols-${Math.min(
            numColumns,
            4
          )} gap-${colGap} [&>p]:hidden">`;
        } else if (node.value.trim().endsWith("@@@") && inGrid) {
          inGrid = false;
          node.type = "html";
          node.value = `</div>`;
        }
      }
    });
  };
};

export default remarkGridPlugin;
